import { ref } from 'vue';

export function useCustomForms(initialForms: any[]) {
  const customForms = ref([{
    heading: 'Seus modelos',
    hideDivider: true,
    items: initialForms.map((form) => ({
      title: form.name,
      value: form.id,
      leadingIcon: {
        name: 'treatment'
      }
    }))
  }]);

  return {
    customForms
  };
} 